import { memo } from 'react';
import cs from 'classnames';

import { makeStyles } from 'design-system/product/theme';

/* eslint-disable restrict-imports/restrict-imports */
import Chip, { ChipProps } from '@material-ui/core/Chip';

type ChipColors = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

const customColors = ['error', 'success', 'warning'];

function isCustomColor(value: string): value is 'error' | 'success' | 'warning' {
  return customColors.includes(value);
}

type CatalogChipProps = Omit<ChipProps, 'color'> & {
  color: ChipColors;
};

const CatalogChip = ({ color, ...otherProps }: CatalogChipProps) => {
  const classes = useStyles();

  return (
    <Chip
      className={cs(classes.root, isCustomColor(color) ? classes[color] : '')}
      {...otherProps}
    />
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
  },
  warning: {
    color: theme.palette.getContrastText(theme.palette.warning.main),
    backgroundColor: theme.palette.warning.main,
  },
  success: {
    color: theme.palette.getContrastText(theme.palette.success.main),
    backgroundColor: theme.palette.success.main,
  },
  error: {
    color: theme.palette.getContrastText(theme.palette.error.main),
    backgroundColor: theme.palette.error.main,
  },
}));

export default memo(CatalogChip);
